import { render, staticRenderFns } from "./SvcRequest.vue?vue&type=template&id=65129aad&scoped=true&"
import script from "./SvcRequest.vue?vue&type=script&lang=js&"
export * from "./SvcRequest.vue?vue&type=script&lang=js&"
import style0 from "./SvcRequest.vue?vue&type=style&index=0&id=65129aad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65129aad",
  null
  
)

export default component.exports